<template>
  <OModal v-model="isActive" class="ow-contact-form-modal" @close="closeContactForm">
    <div class="ow-contact-form">
      <div class="ow-contact-form-header">
        <div class="ow-contact-form-header-logo-wrapper">
          <img src="/images/OxiaLogoAllWhite.png" alt="Icon" class="ow-contact-form-header-logo" />
        </div>
        <h3 class="ow-contact-form-header-title ow-heading-3">Contact us</h3>
        <button class="ow-contact-form-close os-icon icon-x" @click="closeContactForm()"></button>
      </div>
      <div class="ow-contact-form-body oxia-theme-default os-grid has-12-rows">
        <InputText label="Title"
          class="os-grid-cell cols-4-md"
          isRequired
          labelClass="text-left"
          v-model="title"
          />
        <InputText label="Name"
          class="os-grid-cell cols-4-md"
          isRequired
          labelClass="text-left"
          :isDisabled="title === ''"
          v-model="firstName"
          />
        <InputText label="Surname"
          class="os-grid-cell cols-4-md"
          isRequired
          :isDisabled="firstName === ''"
          labelClass="text-left"
          v-model="lastName"
          />
          <InputText label="Subject"
          class="os-grid-cell cols-6-md"
          isRequired
          labelClass="text-left"
          :isDisabled="lastName === ''"
          v-model="messageSubject"
          />
        <InputText label="Email"
          class="os-grid-cell cols-6-md"
          type="email"
          isRequired
          labelClass="text-left"
          :isDisabled="messageSubject === ''"
          v-model="email"
          />
        <InputText label="Message" v-model="message" type="textarea" isRequired widget-class="os-grid-cell cols-12" :isDisabled="email === ''"/>
        <div class="os-grid-cell cols-3-md"></div>
        <div class="ow-contact-form-captcha-wrapper os-grid-cell cols-6-md">
          <OCaptcha v-model="isCaptchaValid" :isDisabled="message === ''" />
        </div>
      </div>
      <div class="ow-contact-form-footer oxia-theme-default">
        <button class="ow-contact-form-footer-button is-half" :disabled="isSubmitDisabled" @click="submitButtonClicked">SUBMIT</button>
      </div>
    </div>
    <OLoader name="dots" message="Sending email" isFullPage v-model="isLoaderActive" />
  </OModal>
</template>

<script setup lang="ts">
import { InputText, OCaptcha } from '@oxia/client';
import { computed, ref } from 'vue';
import { generateHtmlMessage, sendMessageToEmail } from '../utils/emailHelper';

const isActive = defineModel({ type: Boolean, default: false })

// const $toast = useToast();

const title = ref('');
const firstName = ref('');
const lastName = ref('');
const email = ref('');
const messageSubject = ref('');
const message = ref('');
const isCaptchaValid = ref(false);
const isLoaderActive = ref(false);

const isSubmitDisabled = computed(() => {
  return title.value === '' || firstName.value === '' || lastName.value === '' || email.value === '' || messageSubject.value === '' || message.value === '' || !isCaptchaValid.value;
})

const closeContactForm = () => {
  isActive.value = false;
}

const resetValues = () => {
  title.value = '';
  firstName.value = '';
  lastName.value = '';
  email.value = '';
  messageSubject.value = '';
  message.value = '';
  isCaptchaValid.value = false;
}

const submitButtonClicked = async () => {
  try {
    isLoaderActive.value = true;
    const emailToSend = {
      to: 'support@oxia.org',
      subject: messageSubject.value,
      message: {
        title: 'OxIA Website Contact Form',
        html: generateHtmlMessage(`${title.value} ${firstName.value} ${lastName.value}`, email.value, [message.value]),
        signature: true,
        disclaimer: true
      }
    }
    await sendMessageToEmail(emailToSend)
    closeContactForm();
    resetValues();
    isLoaderActive.value = false;
    // https://www.restack.io/p/nuxt-error-answer-troubleshooting-guide
    // https://www.lichter.io/articles/vue-hydration-error/
    // $toast.show({ message: 'Your message was successfuly submitted. Carbon copy of your message will be sent to the provided email.', isCloseable: true });
  }
  catch (error) {
    console.log(error);
    isLoaderActive.value = false;
    // https://www.lichter.io/articles/vue-hydration-error/
    // $toast.show({ message: 'An error occurred. Your message was not submitted successfuly.', isCloseable: true, className: 'is-alert' });
  }
}
</script>

<style lang='scss'>

</style>